<template>
  <hm-content title="">
    <div class="">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
      >
        <div class="rule-title">1.分佣计算设置</div>
        <el-form-item label="返拥级数" prop="commissionLevel">
          <el-select
            clearable
            v-model="ruleForm.commissionLevel"
            placeholder="请选择返拥级数"
            size="small"
            class="mr10"
            @change="selectLevel"
          >
            <el-option
              :label="v"
              :value="v"
              v-for="(v, i) in SeriesList"
              :key="i"
            ></el-option>
          </el-select>
          <div class="form-item-tip">
            由于国家法律法规管控，建议分销模式不要超过三级。
          </div>
          <el-button class="blue" type="text" size="mini"
            >点我查看模式说明》</el-button
          >
        </el-form-item>
        <el-form-item
          prop="commissionDouble"
          v-if="ruleForm.ratioRelModels.length > 0"
        >
          <span slot="label">{{ ruleForm.commissionLevel }}级分佣</span>
          <div v-for="(v, i) in ruleForm.ratioRelModels" :key="i">
            {{ v.level }}级分销返佣
            <el-input
              clearable
              size="small"
              class="mr10 ipt"
              @input="filterGt0OrFixed22('ratioValue', i)"
              v-model.trim="v.ratioValue"
              placeholder="输入返佣比例"
              @blur="checkNum(i)"
            ></el-input
            >%
          </div>

          <!-- <div>
            上级分销返佣
            <el-input
              clearable
              size="small"
              class="mr10 ipt"
              @input="filterGt0OrFixed2('commissionSuperior')"
              v-model.trim="ruleForm.commissionSuperior"
              placeholder="最小1、最大100"
              @change="superior"
            ></el-input
            >%
          </div> -->
          <div class="form-item-tip">
            终端分销和上级分销返佣百分数之和为100，填写任意一级返佣百分数，另一级将自动生成。
          </div>
        </el-form-item>
        <el-form-item
          label="分销会员自购返佣"
          prop="shareMemberSelfpurchaseMode"
        >
          <el-switch
            v-model="ruleForm.shareMemberSelfpurchaseMode"
            active-text="开启"
            inactive-text="关闭"
            active-color="#13ce66"
            active-value="enabled"
            inactive-value="disabled"
          >
          </el-switch>
          <div class="form-item-tip">
            开启后，分销会员购买商品，自己会直接获取该订单的佣金，并依次计算上级分销会员佣金。
          </div>
        </el-form-item>
        <el-form-item
          label="推荐关系锁定周期"
          prop="recommendedPurchaseExpiresDays"
        >
          <el-input
            clearable
            size="small"
            v-model="ruleForm.recommendedPurchaseExpiresDays"
            type="number"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
            @input="filterGt0OrFixed0('recommendedPurchaseExpiresDays')"
            @mousewheel.prevent.native
            maxlength="50"
            placeholder="最小1、最大不限"
          ></el-input
          >天
          <div class="form-item-tip">
            推荐并成功将消费者引入购物环境，只要在设置周期内发生购买行为且符合分佣规则，则产生佣金。
          </div>
        </el-form-item>
        <el-form-item
          label="佣金发放类型"
          prop="recommendedPurchaseExpiresDays"
          v-if="isOpenCommissionMode"
        >
          <span class="form-red">
            (内部人员指在职员列表有数据,且在职的人员，其余为外部人员。)
          </span>
          <div>
            <div>
              内部人员：
              <el-radio-group
                v-model="ruleForm.internalPersonCommissionMode"
                size="small"
                class="mr20"
              >
                <el-radio label="oneself">自发佣金</el-radio>
                <el-radio label="hemiao">代发佣金</el-radio>
              </el-radio-group>
            </div>
            <div>
              外部人员：
              <el-radio-group
                v-model="ruleForm.externalPersonCommissionMode"
                size="small"
                class="mr20"
              >
                <el-radio label="oneself">自发佣金</el-radio>
                <el-radio label="hemiao">代发佣金</el-radio>
              </el-radio-group>
            </div>
          </div>
        </el-form-item>
        <div class="rule-title">2.如何成为分销会员</div>
        <el-form-item label="如何成为分销会员" prop="howtoMainCondition">
          <el-radio-group
            v-model="ruleForm.howtoMainCondition"
            size="small"
            @change="howtoMainChange"
            class="mr20"
          >
            <el-radio label="noCondition">注册即分销</el-radio>
            <el-radio label="haveCondition">条件分销</el-radio>
            <el-radio label="byApply">申请成为推会员</el-radio>
          </el-radio-group>

          <el-checkbox-group
            v-model="ruleForm.howtoSubCondition"
            v-if="ruleForm.howtoMainCondition === 'haveCondition'"
          >
            <el-checkbox label="invite">邀请分销</el-checkbox>
            <el-checkbox label="shopping">购物分销</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <template v-if="ruleForm.howtoMainCondition === 'byApply'">
          <el-form-item label="是否需要审核" prop="needExamineStatus">
            <el-radio-group
              class="mr20"
              v-model="ruleForm.needExamineStatus"
              @change="needExamineIsTypeChange"
            >
              <el-radio label="no">不需要</el-radio>
              <el-radio label="yes" :disabled="!isStoreExamineConfigStates"
                >需要审核</el-radio
              >
            </el-radio-group>
            <el-button
              type="text"
              size="small"
              class="blue"
              @click="goExamineSetting"
              v-if="!isStoreExamineConfigStates"
              >开启成为分销会员审核配置</el-button
            >
          </el-form-item>
          <el-form-item
            label="申请表单"
            prop="formStatus"
            v-if="ruleForm.needExamineStatus === 'yes'"
          >
            <el-radio-group v-model="ruleForm.formStatus">
              <el-radio label="open">开启</el-radio>
              <el-radio label="close">关闭</el-radio>
            </el-radio-group>
            <hm-form ref="hmform" v-if="ruleForm.formStatus === 'open'">
            </hm-form>
          </el-form-item>
          <el-form-item
            label="需要审核人员类型"
            prop="needExamineType"
            v-if="ruleForm.needExamineStatus === 'yes'"
          >
            <el-radio-group v-model="ruleForm.needExamineType">
              <el-radio label="all">全部</el-radio>
              <el-radio label="inside">内部人员需要审核</el-radio>
              <el-radio label="outside">外部人员需要审核</el-radio>
              <el-radio label="other">指定人员需要审核</el-radio>
            </el-radio-group>
            <div
              v-if="ruleForm.needExamineType === 'other'"
              style="width: 600px;"
            >
              <div class="flex flex-end">
                <div @click="outputExcel" class="delete mr20 pointer">
                  <span class="delete-icon hmicon icon-daochu"></span>
                  导出模板
                </div>
                <div class="delete mr20 pointer open-file">
                  <span class="delete-icon hmicon icon-daoru"></span>
                  导入模板
                  <input
                    type="file"
                    @change="importf"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  />
                </div>
              </div>
              <div>
                <el-table
                  stripe
                  ref="roleTable"
                  :data="ruleForm.personRelModels"
                  style="width: 100%"
                  id="table"
                  size="small"
                  max-height="500px"
                  border
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    header-align="center"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="手机号"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.phone }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button
                        size="small"
                        type="text"
                        @click="del(scope.$index)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-form-item>
        </template>

        <el-form-item
          label="分销商品"
          prop="skuRelModels"
          v-if="
            ruleForm.howtoSubCondition.includes('shopping') &&
              ruleForm.howtoMainCondition === 'haveCondition'
          "
        >
          <el-button type="primary" size="small" plain @click="addWxGoogs"
            >+ 添加商品</el-button
          >
          <div class="table mb10">
            <el-table
              stripe
              ref="roleTable"
              :data="ruleForm.skuRelModels"
              style="width: 100%"
              id="table"
              size="small"
              border
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="wxshopSpuName"
                label="商品名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="价格信息"
              >
                <template slot-scope="scope">
                  <div>
                    <span>建议零售价：</span>
                    <span class="rose">{{ scope.row.wxshopPrice }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip class="item" content="删除" placement="top">
                      <div
                        class="pointer mr10"
                        @click="removeGoods(scope.$index)"
                      >
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <div class="rule-title">3.提现管理</div>
        <el-form-item label="提现时段" prop="perMonthAllowGetcashTime">
          <el-input
            clearable
            size="small"
            v-model="ruleForm.perMonthAllowGetcashStartdate"
            type="number"
            style="width:200px;"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
            @mousewheel.prevent.native
            maxlength="50"
            placeholder="请设置每月提现开始时间"
          ></el-input>
          --
          <el-input
            clearable
            size="small"
            style="width:200px;"
            v-model="ruleForm.perMonthAllowGetcashEnddate"
            type="number"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
            @mousewheel.prevent.native
            maxlength="50"
            placeholder="请设置每月提现截止时间"
          ></el-input>
          <span class="form-tip">(注:每月提现周期。)</span>
        </el-form-item>
        <el-form-item label="单笔提现限制下限" prop="singleGetcashLowerLimit">
          <el-input
            clearable
            size="small"
            v-model.trim="ruleForm.singleGetcashLowerLimit"
            @input="filterGt0OrFixed2('singleGetcashLowerLimit')"
            @mousewheel.prevent.native
            maxlength="50"
            placeholder="建议不低于50"
          ></el-input>
        </el-form-item>
        <el-form-item label="单笔提现限制上限" prop="singleGetcashUpperLimit">
          <el-input
            clearable
            size="small"
            v-model.trim="ruleForm.singleGetcashUpperLimit"
            @input="filterGt0OrFixed2('singleGetcashUpperLimit')"
            @mousewheel.prevent.native
            maxlength="50"
            placeholder="建议不高于500"
          ></el-input>
        </el-form-item>
        <div class="rule-title">4.到期管理<span class="tips ml10">{{tips}}</span></div>
        <el-form-item prop="withdrawalClosingDays">
          到期
          <el-input
            clearable
            size="small"
            v-model.trim="ruleForm.withdrawalClosingDays"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
            @input="filterGt0OrFixed0('withdrawalClosingDays')"
            @mousewheel.prevent.native
            maxlength="50"
            placeholder="请输入天数"
          ></el-input
          >天后，关闭提现通道。
        </el-form-item>
        <el-form-item prop="relationClosingDays">
          到期
          <el-input
            clearable
            size="small"
            v-model.trim="ruleForm.relationClosingDays"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
            @input="filterGt0OrFixed0('relationClosingDays')"
            @mousewheel.prevent.native
            maxlength="50"
            placeholder="请输入天数"
          ></el-input
          >天后，清空关联关系。
        </el-form-item>
        <el-form-item prop="sendMsgDays">
          到期
          <el-input
            clearable
            size="small"
            v-model.trim="ruleForm.sendMsgDays"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
            @input="filterGt0OrFixed0('sendMsgDays')"
            @mousewheel.prevent.native
            maxlength="50"
            placeholder="请输入天数"
          ></el-input
          >天前，发送到期提醒短信。
        </el-form-item>
        <el-form-item prop="dueDays">
          <span class="red">*</span>
          分销会员有效期
          <el-input
            clearable
            size="small"
            v-model.trim="ruleForm.dueDays"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
            @input="filterGt0OrFixed0('dueDays')"
            @mousewheel.prevent.native
            maxlength="50"
            placeholder="请输入天数"
          ></el-input
          >天。
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="$router.back(-1)">返回</el-button>
        </div>
      </el-form>
    </div>
    <el-dialog
      title="添加商品"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoods"
    >
      <div class="table-panel flex  flex-end">
        <div class="flex text-right  flex-end">
          <el-input
            clearable
            style="width:200px;"
            v-model.trim="searchDialogCondition.keyWords"
            placeholder="请输入货号/条码/商品名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-cascader
            v-model="searchDialogCondition.wxshopCategoryId"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="categoryFunc"
            clearable
            placeholder="请选择微店商品分类"
          ></el-cascader>
          <el-cascader
            v-model="searchDialogCondition.attributeId"
            placeholder="请选择辅助属性"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="attributeFunc"
            clearable
          ></el-cascader>
          <el-input
            clearable
            v-model.trim="searchDialogCondition.minPrice"
            placeholder="最低零售价"
            size="small"
            style="width: 100px"
            class="ipt mr10"
          ></el-input>
          <el-input
            clearable
            v-model.trim="searchDialogCondition.maxPrice"
            placeholder="最高零售价"
            size="small"
            style="width: 100px"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchGoods"
            >查询</el-button
          >
          <el-button
            type="info"
            size="small"
            @click="searchDialogCondition = {}"
            >重置</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table
          stripe
          border
          class="mb20"
          ref="brandTable"
          @selection-change="getChecked"
          :data="wxShopList.records"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentMicroPage - 1) * pageMicroSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="产品名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            show-overflow-tooltip
            label="规格"
          >
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.spuAttributeValueList.join() }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            show-overflow-tooltip
            label="类别"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="价格信息"
          >
            <template slot-scope="scope">
              <div>
                <span>建议零售价：</span>
                <span class="rose">{{ scope.row.wxshopPrice }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="wxShopList.total"
          @current-change="pagingMicro"
          @size-change="handleSizeMicroChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentMicroPage"
        ></el-pagination>
      </div>
      <div class="flex flex-center mt20">
        <el-button type="primary" size="small" @click="affirm">确认</el-button>
        <el-button size="small" @click="dialogVisibleGoods = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmForm from "@/components/HmForm";
import { mapGetters } from "vuex";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { HmForm },
  data() {
    const patternFormStatus = (rule, val, callback) => {
      if (val === "open") {
        if (this.$refs.hmform.list.length === 0) {
          return callback(new Error("请选择表单"));
        } else {
          let flag = false;
          this.$refs.hmform.list.forEach(v => {
            if (v.columnValue === "") {
              flag = true;
            }
            if (v.columnType === "radio") {
              v.paramInfoModels.forEach(o => {
                if (o.columnValue === "") {
                  flag = true;
                }
              });
            }
          });
          if (flag) {
            return callback(new Error("请把表单填写完整"));
          }
        }
      }
      callback();
    };
    const commissionDoubleFunc = function(rule, val, callback) {
      this.ruleForm.ratioRelModels.map(v => {
        if (v.ratioValue === "") {
          return callback(new Error("请填写分佣比例"));
        } else {
          if (this.deficiency) {
            return callback(new Error(`分佣比例总和应为100,还差${this.num}`));
          }
        }
      });
      // if (
      //   this.ruleForm.commissionTerminal === "" ||
      //   this.ruleForm.commissionSuperior === ""
      // ) {
      //   return callback(new Error("请填写两级分佣比例"));
      // }
      callback();
    }.bind(this);
    const patternTimeFunc = function(rule, val, callback) {
      if (
        !this.ruleForm.perMonthAllowGetcashStartdate ||
        !this.ruleForm.perMonthAllowGetcashEnddate
      ) {
        return callback(new Error("请输入每月提现周期"));
      } else {
        if (
          this.ruleForm.perMonthAllowGetcashStartdate > 31 ||
          this.ruleForm.perMonthAllowGetcashEnddate > 31
        ) {
          return callback(new Error("提现周期最大值不得大于31"));
        }
      }
      callback();
    }.bind(this);
    const conditionCommissionFunc = function(rule, val, callback) {
      if (
        val === "haveCondition" &&
        this.ruleForm.howtoSubCondition.length < 1
      ) {
        return callback(new Error("请选择条件"));
      }
      callback();
    }.bind(this);
    return {
      total: 100,
      num: 0,
      deficiency: false,
      checkedRow: [],
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      dialogVisibleGoods: false,
      currentMicroPage: 1,
      pageMicroSize: 10,
      searchDialogCondition: {},
      SeriesList: [],
      ruleForm: {
        ratioRelModels: [],
        commissionLevel: "",
        newRuleId: "",
        formStatus: "no",
        shareMemberSelfpurchaseMode: "disabled",
        recommendedPurchaseExpiresDays: "",
        internalPersonCommissionMode: "hemiao",
        externalPersonCommissionMode: "hemiao",
        needExamineStatus: "",
        needExamineType: "",
        personRelModels: [],
        howtoMainCondition: "",
        howtoSubCondition: [],
        skuRelModels: [],
        perMonthAllowGetcashTime: [],
        perMonthAllowGetcashStartdate: "",
        perMonthAllowGetcashEnddate: "",
        singleGetcashLowerLimit: "",
        singleGetcashUpperLimit: "",
        withdrawalClosingDays: "",
        relationClosingDays: "",
        sendMsgDays: "",
        dueDays: "10000"
      },
      rules: {
        commissionLevel: {
          required: true,
          message: "请选择返拥级数",
          trigger: "blur"
        },
        commissionDouble: {
          required: true,
          validator: commissionDoubleFunc,
          trigger: "blur"
        },
        shareMemberSelfpurchaseMode: {
          required: true,
          message: "请选择分销会员自购返佣",
          trigger: "blur"
        },
        recommendedPurchaseExpiresDays: {
          required: true,
          message: "请填写锁定周期",
          trigger: "blur"
        },
        howtoMainCondition: [
          {
            required: true,
            message: "请选择如何成为分销会员",
            trigger: "blur"
          },
          {
            required: true,
            validator: conditionCommissionFunc,
            trigger: "blur"
          }
        ],
        formStatus: [
          {
            required: true,
            message: "请选择表单状态",
            trigger: "blur"
          },
          { required: true, validator: patternFormStatus, trigger: "change" }
        ],
        needExamineStatus: {
          required: true,
          message: "请选择是否需要审核",
          trigger: "blur"
        },
        needExamineType: {
          required: true,
          message: "请选择需要审核人员类型",
          trigger: "blur"
        },
        skuRelModels: {
          required: true,
          message: "请添加商品",
          trigger: "blur"
        },
        perMonthAllowGetcashTime: {
          required: true,
          validator: patternTimeFunc,
          trigger: "blur"
        },
        singleGetcashLowerLimit: {
          required: true,
          message: "请填写单笔提现限制下限",
          trigger: "blur"
        },
        singleGetcashUpperLimit: [
          {
            required: true,
            message: "请填写单笔提现限制上限",
            trigger: "blur"
          }
        ],
        withdrawalClosingDays: {
          required: false,
          message: "请填写提现关闭时间",
          trigger: "blur"
        },
        relationClosingDays: {
          required: false,
          message: "请填写关联关系关闭时间",
          trigger: "blur"
        },
        sendMsgDays: {
          required: false,
          message: "请填写发送短信时间",
          trigger: "blur"
        },
        dueDays: {
          required: true,
          message: "请填写分销会员有效期",
          trigger: "blur"
        }
      },
      isStoreExamineConfigStates: false,
      isOpenCommissionMode: false
    };
  },
  computed: mapGetters(["wxShopList"]),
  watch: {},
  created() {},
  async mounted() {
    const { result } = await this.$store.dispatch("queryCommissionLevelLimt", {
      code: "commissionLevelLimt"
    });
    this.SeriesList = +result.value;
    this.details();
    this.queryMicroShopGoodsList();
    this.queryStoreExamineConfigStates();
    this.shareAgentDistributioRuleMemberDuedayDesc();
  },
  methods: {
    goExamineSetting() {
      this.$router.push({
        name: "AuditConfiguration"
      });
    },
    async queryStoreExamineConfigStates() {
      const { result } = await this.$store.dispatch(
        "queryStoreExamineConfigStates",
        {
          examineType: "申请成为推会员"
        }
      );
      this.isStoreExamineConfigStates = result;
    },
    del(i) {
      this.ruleForm.personRelModels.splice(i, 1);
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["手机号"];
        const data = [];

        exportJsonToExcel(tHeader, data, "导出模板");
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];

        let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        result.forEach(v => {
          if (myreg.test(v[0])) {
            formatResult.push({ phone: v[0] });
          }
        });
        console.log("formatResult: ", formatResult);
        console.log(" that.ruleForm.personRelModels: ", that.ruleForm);
        that.ruleForm.personRelModels.push(...formatResult);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    checkNum(i) {
      const len = this.ruleForm.ratioRelModels.filter(
        v => !v.ratioValue && v.ratioValue !== 0
      ).length;

      let total = this.getTotal();
      if (total > this.total) {
        this.ruleForm.ratioRelModels[i].ratioValue = "";
        this.ruleForm.ratioRelModels[i].ratioValue =
          this.total - this.getTotal();
      }
      const index = this.ruleForm.ratioRelModels.findIndex(v => !v.ratioValue);
      if (len === 1 && index !== i) {
        if (total <= this.total) {
          this.ruleForm.ratioRelModels[index].ratioValue = this.total - total;
        }
      }
    },
    getTotal() {
      let total = 0;
      this.ruleForm.ratioRelModels.map(v => (total += +v.ratioValue));
      return total;
    },
    howtoMainChange(val) {
      if (val === "noCondition") {
        this.ruleForm.howtoSubCondition = [];
        this.ruleForm.skuRelModels = [];
      }
      if (val === "byApply") {
        this.ruleForm.needExamineStatus = "no";
      }
    },
    needExamineIsTypeChange(val) {
      if (val === "yes") {
        this.ruleForm.needExamineType = "all";
      }
    },
    async shareAgentDistributioRuleMemberDuedayDesc() {
      const { result } = await this.$store.dispatch(
        "shareAgentDistributioRuleMemberDuedayDesc"
      );
      if(result){
        this.tips = "(" + result.textContentZhCn + ")";
      }
    },
    async details() {
      const { result } = await this.$store.dispatch(
        "detailsShareRuleConfigNew"
      );
      result.howtoSubCondition = result.howtoSubCondition.split(",");
      if (
        result.storeCode === "42010216070190" ||
        result.storeCode === "53010017032439"
      ) {
        this.isOpenCommissionMode = true;
        result.internalPersonCommissionMode = result.internalPersonCommissionMode
          ? result.internalPersonCommissionMode
          : "hemiao";
        result.externalPersonCommissionMode = result.externalPersonCommissionMode
          ? result.externalPersonCommissionMode
          : "hemiao";
      }
      for (let key in result) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = result[key];
        }
      }
      setTimeout(() => {
        if (this.$refs.hmform && result.formStatus === "open") {
          this.$refs.hmform.list = result.columnsInfoModels;
        }
      }, 1000);
      this.ruleForm.personRelModels = result.personRelModels || [];
    },
    selectLevel(val) {
      this.ruleForm.ratioRelModels = [];
      for (let i = 1; i <= val; i++) {
        this.ruleForm.ratioRelModels.push({
          level: i,
          ratioValue: ""
        });
      }
      if (this.ruleForm.ratioRelModels.length === 1) {
        this.ruleForm.ratioRelModels[0].ratioValue = 100;
      }
    },
    terminal(val, i) {
      this.deficiency = false;
      let total = 0;
      this.ruleForm.ratioRelModels.map(v => {
        total += +v.ratioValue;
      });
      if (total > 100) {
        this.ruleForm.ratioRelModels[i].ratioValue = "";
      } else if (total < 100) {
        this.num = 100 - total;
        this.deficiency = true;
      }
    },

    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed2(prop) {
      if (prop === "commissionTerminal" || prop === "commissionSuperior") {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      }
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixed22(prop, i) {
      // this.ruleForm.ratioRelModels[i][prop] = this.ruleForm.ratioRelModels[i][
      //   prop
      // ].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.ratioRelModels[i][prop] = this.ruleForm.ratioRelModels[i][
        prop
      ].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.ratioRelModels[i][prop] = this.ruleForm.ratioRelModels[i][
        prop
      ].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.ratioRelModels[i][prop] = this.ruleForm.ratioRelModels[i][
        prop
      ]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.ratioRelModels[i][prop] = this.ruleForm.ratioRelModels[i][
        prop
      ].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.ruleForm.ratioRelModels[i][prop].indexOf(".") < 0 &&
        this.ruleForm.ratioRelModels[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.ratioRelModels[i][prop] = parseFloat(
          this.ruleForm.ratioRelModels[i][prop]
        );
      }
    },
    addWxGoogs() {
      this.dialogVisibleGoods = true;
    },
    queryMicroShopGoodsList() {
      let params = {
        pageSize: this.pageMicroSize,
        pageNo: this.currentMicroPage,
        spuType: "virtual"
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );
      searchDialogCondition.wxshopCategoryId = this.isArray(
        searchDialogCondition.wxshopCategoryId
      )
        ? searchDialogCondition.wxshopCategoryId[
            searchDialogCondition.wxshopCategoryId.length - 1
          ]
        : searchDialogCondition.wxshopCategoryId;

      searchDialogCondition.attributeId = this.isArray(
        searchDialogCondition.attributeId
      )
        ? searchDialogCondition.attributeId[
            searchDialogCondition.attributeId.length - 1
          ]
        : "";
      Object.assign(params, searchDialogCondition);
      return this.$store.dispatch("queryWxshopList", params);
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },
    affirm() {
      if (this.checkedRow.length > 0) {
        if(this.ruleForm.skuRelModels === null){
          this.ruleForm.skuRelModels = [];
        }
        this.checkedRow.forEach(v => {
          let show = false;
          this.ruleForm.skuRelModels.forEach(item => {
            if (item.wxshopSkuId === v.wxshopSkuId) {
              show = true;
            }
          });
          if (!show) {
            this.ruleForm.skuRelModels.push(v);
          }
        });
        // this.ruleForm.skuRelModels.push(...this.checkedRow);
        this.dialogVisibleGoods = false;
      } else {
        this.$message({
          message: "请选择商品！",
          type: "warning"
        });
      }
    },
    pagingMicro(page) {
      this.currentMicroPage = page;
      this.queryMicroShopGoodsList();
    },
    handleSizeMicroChange(size) {
      this.currentMicroPage = 1;
      this.pageMicroSize = size;
      this.queryMicroShopGoodsList();
    },
    searchGoods() {
      this.currentMicroPage = 1;
      this.queryMicroShopGoodsList();
    },
    removeGoods(index) {
      this.ruleForm.skuRelModels.splice(index, 1);
    },
    async submitForm(ruleForm) {
      const valid = await this.$refs[ruleForm].validate();
      if (valid) {
        if (
          this.ruleForm.singleGetcashUpperLimit <
          this.ruleForm.singleGetcashLowerLimit
        ) {
          this.$message({
            message: "提现上限不得小于提现下限",
            type: "warning"
          });
        } else {
          let total = 0;
          this.ruleForm.ratioRelModels.map(v => {
            total += +v.ratioValue;
          });
          if (total !== 100) {
            this.$message({
              message: "分佣比例总和应为100",
              type: "warning"
            });
          } else {
            let params = JSON.parse(JSON.stringify(this.ruleForm));
            params.columnsInfoModels = [];
            if (this.$refs.hmform && params.formStatus === "open") {
              params.columnsInfoModels = this.$refs.hmform.list;
            }
            params.howtoSubCondition = params.howtoSubCondition.join(",");
            const { code } = await this.$store.dispatch(
              "addShareRuleConfigNew",
              params
            );
            if (code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.details();
            }
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.rule-title {
  font-size: 22px;
  margin-bottom: 10px;
  font-family: PingFang SC;
  color: rgba(34, 34, 34, 1);
}
.tips{
  color: #E50065;
}
.red{
  font-size: 20px;
  color: #E50065;
  padding-top: 4px;
  display: block;
  float: left;
}
</style>
